import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PopinOneComponent } from './popin-one/popin-one.component';
import { TestComponent } from './test/test.component';
import { PopinTwoComponent } from './popin-two/popin-two.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { PopinVisitorComponent } from './popin-visitor/popin-visitor.component';
import { PopinThreeComponent } from './popin-three/popin-three.component';
import { PopinFourComponent } from './popin-four/popin-four.component';
import {PopinService} from './services/popin.service';
import {HttpClientModule} from '@angular/common/http';
import {ApiCoefficyService} from './services/api-coefficy.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSelectModule} from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {Data} from './providers/data.provider';
import { VisitorRedirectComponent } from './visitor-redirect/visitor-redirect.component';
import {NotificationService} from './services/notification.service';
import { FourOhFourComponent } from './four-oh-four/four-oh-four.component';
import {AuthService} from './services/auth.service';
import { PopinExitComponent } from './popin-exit/popin-exit.component';
import {DatasaveService} from './services/datasave.service';
import {IpService} from './services/ip.service';

@NgModule({
  declarations: [
    AppComponent,
    PopinOneComponent,
    TestComponent,
    PopinTwoComponent,
    PopinVisitorComponent,
    PopinThreeComponent,
    PopinFourComponent,
    VisitorRedirectComponent,
    FourOhFourComponent,
    PopinExitComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
  ],
  providers: [
    PopinService,
    ApiCoefficyService,
    NotificationService,
    DatasaveService,
    AuthService,
    IpService,
    Data
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
